<div class="container-fliud">

  <!-- Patreon Card Here -->
  <div *ngIf="showFooter" class="">

    <div class="">
      <div class="patreon-card" style="border: none; background-color: #ffebda;">
        <div class="row no-gutters cl_animation1">

          <div class="col-md-8" style="text-align: center;">
            <div class="card-body patreon-body">
              <h5 class="card-title patreon_head">Want Early Build access ? </h5>
              <p class="pat-card-sum">Join us on patreon for
                exclusivity.
                Choose the tier that suits your requirement and it starts from 3$ </p>
              <br>

              <div>
                <footer class="blockquote-footer"> Exclusive build & features that aren't available for public
                </footer>
                <footer class="blockquote-footer"> Get latest bugfixes and active development builds
                </footer>
                <footer class="blockquote-footer"> Early Build access with source update</footer>
                <footer class="blockquote-footer"> Sponsor & VIP Tag in our Website</footer>
                <footer class="blockquote-footer"> Personal Build with Requested Feature</footer>
                <footer class="blockquote-footer"> If needed then private chat support for builds related
                  issues</footer>
                <footer class="blockquote-footer"> Access to full source</footer>
                <footer class="blockquote-footer"> Exclusive voting power</footer>
                <footer class="blockquote-footer"> Full Guidance and Support from TEAM</footer>
              </div>
              <br>

            </div>
          </div>

          <div class="col-md-4 patreon-card-right">

            <img src="./assets/images/patreon.png" class="card-img patreon_new-cl" alt="img">

            <a target="_blank" href="https://www.patreon.com/join/uglykid24">
              <p> <a class="btn shadow patreon-btn" style="display: inline-block;">
                  <svg width="22" height="22" viewBox="0 -4.5 256 256" version="1.1" class="bi bi-patreon"
                    xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
                    preserveAspectRatio="xMidYMid">
                    <g>
                      <path
                        d="M45.1355837,0 L45.1355837,246.35001 L0,246.35001 L0,0 L45.1355837,0 Z M163.657111,0 C214.65668,0 256,41.3433196 256,92.3428889 C256,143.342458 214.65668,184.685778 163.657111,184.685778 C112.657542,184.685778 71.3142222,143.342458 71.3142222,92.3428889 C71.3142222,41.3433196 112.657542,0 163.657111,0 Z"
                        fill="#ffffff"></path>
                    </g>
                  </svg> Join us on Patreon
                </a>
              </p>
            </a>

            <a target="_blank" href="https://www.buymeacoffee.com/Uglykid">
              <p> <a class="btn shadow patreon-btn" style="display: inline-block; letter-spacing: 2px;">
                  <svg fill="#ffffff" width="26" height="26" class="bi bi-patreon" viewBox="0 0 24 24" role="img"
                    xmlns="http://www.w3.org/2000/svg">
                    <path
                      d="m20.216 6.415-.132-.666c-.119-.598-.388-1.163-1.001-1.379-.197-.069-.42-.098-.57-.241-.152-.143-.196-.366-.231-.572-.065-.378-.125-.756-.192-1.133-.057-.325-.102-.69-.25-.987-.195-.4-.597-.634-.996-.788a5.723 5.723 0 0 0-.626-.194c-1-.263-2.05-.36-3.077-.416a25.834 25.834 0 0 0-3.7.062c-.915.083-1.88.184-2.75.5-.318.116-.646.256-.888.501-.297.302-.393.77-.177 1.146.154.267.415.456.692.58.36.162.737.284 1.123.366 1.075.238 2.189.331 3.287.37 1.218.05 2.437.01 3.65-.118.299-.033.598-.073.896-.119.352-.054.578-.513.474-.834-.124-.383-.457-.531-.834-.473-.466.074-.96.108-1.382.146-1.177.08-2.358.082-3.536.006a22.228 22.228 0 0 1-1.157-.107c-.086-.01-.18-.025-.258-.036-.243-.036-.484-.08-.724-.13-.111-.027-.111-.185 0-.212h.005c.277-.06.557-.108.838-.147h.002c.131-.009.263-.032.394-.048a25.076 25.076 0 0 1 3.426-.12c.674.019 1.347.067 2.017.144l.228.031c.267.04.533.088.798.145.392.085.895.113 1.07.542.055.137.08.288.111.431l.319 1.484a.237.237 0 0 1-.199.284h-.003c-.037.006-.075.01-.112.015a36.704 36.704 0 0 1-4.743.295 37.059 37.059 0 0 1-4.699-.304c-.14-.017-.293-.042-.417-.06-.326-.048-.649-.108-.973-.161-.393-.065-.768-.032-1.123.161-.29.16-.527.404-.675.701-.154.316-.199.66-.267 1-.069.34-.176.707-.135 1.056.087.753.613 1.365 1.37 1.502a39.69 39.69 0 0 0 11.343.376.483.483 0 0 1 .535.53l-.071.697-1.018 9.907c-.041.41-.047.832-.125 1.237-.122.637-.553 1.028-1.182 1.171-.577.131-1.165.2-1.756.205-.656.004-1.31-.025-1.966-.022-.699.004-1.556-.06-2.095-.58-.475-.458-.54-1.174-.605-1.793l-.731-7.013-.322-3.094c-.037-.351-.286-.695-.678-.678-.336.015-.718.3-.678.679l.228 2.185.949 9.112c.147 1.344 1.174 2.068 2.446 2.272.742.12 1.503.144 2.257.156.966.016 1.942.053 2.892-.122 1.408-.258 2.465-1.198 2.616-2.657.34-3.332.683-6.663 1.024-9.995l.215-2.087a.484.484 0 0 1 .39-.426c.402-.078.787-.212 1.074-.518.455-.488.546-1.124.385-1.766zm-1.478.772c-.145.137-.363.201-.578.233-2.416.359-4.866.54-7.308.46-1.748-.06-3.477-.254-5.207-.498-.17-.024-.353-.055-.47-.18-.22-.236-.111-.71-.054-.995.052-.26.152-.609.463-.646.484-.057 1.046.148 1.526.22.577.088 1.156.159 1.737.212 2.48.226 5.002.19 7.472-.14.45-.06.899-.13 1.345-.21.399-.072.84-.206 1.08.206.166.281.188.657.162.974a.544.544 0 0 1-.169.364zm-6.159 3.9c-.862.37-1.84.788-3.109.788a5.884 5.884 0 0 1-1.569-.217l.877 9.004c.065.78.717 1.38 1.5 1.38 0 0 1.243.065 1.658.065.447 0 1.786-.065 1.786-.065.783 0 1.434-.6 1.499-1.38l.94-9.95a3.996 3.996 0 0 0-1.322-.238c-.826 0-1.491.284-2.26.613z" />
                  </svg> Buy Me a Coffee
                </a>
              </p>
            </a>
          </div>

        </div>
      </div>
    </div>

  </div>

  <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
    style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
  </ng2-adsense>

  <div class="container website_animation">

    <div>
      <h1 class="heading"> A screenshot is worth <strong class="key-high">thousand</strong> of words </h1>
    </div>

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <!-- Top 3 highligh screenshots -->
    <div class="container-fliud top-ss-card">
      <div class="card shadow-light bg-body rounded top-ss">
        <div class="container" style="text-align: left; ">
          <p class="top-ss-head">Unique just like you are!</p>
          <p class="top-ss-sum text-muted">Redefine your experience with elixir</p>
        </div>
        <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
          style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
          data-full-width-responsive="true">
        </ng2-adsense>
        <div>
          <img class="card-img-top top-3ss" src="./assets/images/s1.webp" alt="Card image cap">
        </div>
      </div>

      <div class="card shadow-light bg-body rounded top-ss">
        <div class="container" style="text-align: left; ">
          <p class="top-ss-head">Customizations made for you!</p>
          <p class="top-ss-sum text-muted">Personalize profoundly with a lot customizations</p>
        </div>
        <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
          style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
          data-full-width-responsive="true">
        </ng2-adsense>
        <div>
          <img class="card-img-top top-3ss" src="./assets/images/s2.webp" alt="Card image cap">
        </div>
      </div>

      <div class="card shadow-light bg-body rounded top-ss">
        <div class="container" style="text-align: left;">
          <p class="top-ss-head">Whole UI just got refined!</p>
          <p class="top-ss-sum text-muted">With enhanced AOSP now express your style</p>
        </div>
        <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
          style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
          data-full-width-responsive="true">
        </ng2-adsense>
        <div>
          <img class="card-img-top top-3ss" src="./assets/images/s3.webp" alt="Card image cap">
        </div>
      </div>
    </div>

    <!-- <div class="card-deck"> -->

    <!-- <div class="card shadow-light p-3 mb-5 bg-body rounded">
        <div class="card-body">
          <h5 class="card-title">Card title</h5>
          <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional
            content. This content is a little bit longer.</p>
          <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
        </div>

        <img class="card-img-bottom ss" style="padding: 0rem 2.2rem;" src="./assets/images/s1.webp" alt="Card image cap">

      </div> -->

    <!-- <div class="shadow-light bg-body rounded">
        <img class="card-img-top ss" src="./assets/images/s1.webp" alt="Card image cap">
      </div> -->

    <!-- <div class="card shadow-light bg-body rounded" style="padding: 0rem 2rem;">

        <div class="container" style="text-align: left; margin-left: 1.2rem;">

          <p class="" style="font-weight: 600; font-size: 1.6rem; padding-top: 2rem;">Unique like you!</p>
          <p class="text-muted" style="font-weight: 600;">Custom launcher made for customizations</p>
        </div>
        <br>
        <div>
          <img class="card-img-top ss" src="./assets/images/s2.webp" alt="Card image cap">
        </div>

      </div> -->


    <!-- <div class="card shadow-light p-3 mb-5 bg-body rounded">
        <img class="card-img-top ss" src="./assets/images/s3.webp" alt="Card image cap">
        <div class="card-body">
          <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
            style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
            data-full-width-responsive="true">
          </ng2-adsense>
          <p class="card-title">Screenshot No #3</p>
        </div>
      </div> -->
    <!-- 
    </div> -->

    <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
      style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
    </ng2-adsense>

    <div *ngIf="showFooter">
      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s4.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #4</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s5.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #5</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s6.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #6</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>

      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s7.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #7</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s8.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #8</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s9.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #9</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>

      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s10.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #10</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s11.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #11</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s12.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #12</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>

      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s13.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #13</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s14.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #14</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s15.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #15</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>

      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s16.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #16</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s17.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #17</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s18.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #18</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>

      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s19.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #19</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s20.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #20</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s21.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #21</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>

      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s22.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #22</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s23.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #23</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s24.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #24</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>

      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s25.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #25</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s26.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #26</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s27.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #27</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>


      <div class="card-deck">

        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s28.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #28</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s29.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #29</p>
          </div>
        </div>
        <div class="card shadow-light p-3 mb-5 bg-body rounded">
          <img class="card-img-top ss" src="./assets/images/s30.webp" alt="Card image cap">
          <div class="card-body">
            <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
              style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto"
              data-full-width-responsive="true">
            </ng2-adsense>
            <p class="card-title">Screenshot No #30</p>
          </div>
        </div>

      </div>

      <ng2-adsense [adClient]="'ca-pub-1149172094904803'" [adSlot]="1318280513"
        style="display:block;text-align: center; margin: 2rem;" data-ad-format="auto" data-full-width-responsive="true">
      </ng2-adsense>

    </div>

  </div>

</div>

<!-- Footer Support Card -->
<div class="bg-body " style="background-color: #ffebda; padding: 2rem; margin-bottom: -2rem;" *ngIf="showFooter">
  <div class="row justify-content-center">
    <div class=" mb-3 card-radius">
      <div class="row no-gutters">

        <div class="col-md-6">
          <div class="card-body">
            <h2 class="support_line"> Wanna Support Us ? </h2>
            <p class="patreon_highlight">Help to keep Project Elixir active and running by donating. Any
              amount is appreciated.<strong>シ </strong>
            </p>
            <h1> <a href="https://projectelixiros.com/donate">
                <a class="btn shadow footer-support-btn">Donate Now</a>
              </a></h1>

          </div>
        </div>

        <div class="col-md-6 mb-align" style="text-align: center;">
          <img src="./assets/images/donate-phone-hand.webp" class="card-img img-fluid down-carpet-img"
            style="width: 15rem;" alt="avatar">
        </div>

      </div>
    </div>
  </div>
</div>

<div *ngIf="showFooter">
  <app-footer></app-footer>
</div>